import React from "react";
import OfferTemplatePage from "./../pages/OfferTemplatePage";

const OfferFleet = () => {
  return <OfferTemplatePage type="fleet" />;
};

export default OfferFleet;
